import { render } from "./ContactCTA.vue?vue&type=template&id=136b3b1a&scoped=true"
import script from "./ContactCTA.vue?vue&type=script&lang=js"
export * from "./ContactCTA.vue?vue&type=script&lang=js"

import "./ContactCTA.vue?vue&type=style&index=0&id=136b3b1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136b3b1a"]])

export default __exports__